import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  input,
  OnDestroy,
  output,
  viewChild,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { CrossSvgComponent } from '../../svgs';

export type ModalDialogVariant = 'overlay' | 'popup';

/**
 * Shared modal `<dialog>` wrapper for the app's overlay and popup dialogs.
 *
 * Owns the single `showModal()` / `close()` / `onCancel()` lifecycle that used to
 * be copy-pasted across `overlay-layout` and `popup-layout`, and derives its size
 * from the shared `modal-dialog-frame` mixin (overlay variant). See WI 192967.
 */
@Component({
  selector: 'ebeihilfe-modal-dialog',
  templateUrl: './modal-dialog.component.html',
  styleUrls: ['./modal-dialog.component.scss'],
  imports: [CrossSvgComponent, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalDialogComponent implements AfterViewInit, OnDestroy {
  private readonly dialog = viewChild.required<ElementRef<HTMLDialogElement>>('dialog');

  public headline = input<string>();
  public headlineDescription = input<string>();
  public variant = input<ModalDialogVariant>('overlay');
  public closeDialog = output();

  public ngAfterViewInit(): void {
    const dialogElement = this.dialog().nativeElement;
    if (!dialogElement.open) {
      dialogElement.showModal();
    }
  }

  public ngOnDestroy(): void {
    const dialogElement = this.dialog().nativeElement;
    if (dialogElement.open) {
      dialogElement.close();
    }
  }

  public onCancel(event: Event): void {
    // Keep the dialog open on Esc so teardown stays driven by the consumer
    // (routing/state) via closeDialog, matching the close-button behaviour.
    event.preventDefault();
    this.onCloseClick();
  }

  public onCloseClick(): void {
    this.closeDialog.emit();
  }
}
